import { getState, setState } from './stateManager.js';
import { hideIcon, showIcon360, hideIcon360, showIconDown, hideIconDown, clearModal, overlayContentElements, threejsLayer, animateSpline, animateSmart, controls, disableControls, enableControls, getVisibleElementIndex } from  './main.js';
import * as UTIL from './utils.js';

let nextElementToScroll = 0;
let touchStartY = 0;
let isTouching = false;
let isThrottled = false;
let firstStarted = false;

export function initializeScrollHandler(animateSpline, animateSmart, position, getVisibleElementIndex, controls) {
console.log('initializeScrollHandler');
	if(window.innerWidth < 900) {
		window.addEventListener('scroll', handleScroll(animateSpline, position, getVisibleElementIndex, controls));
		window.addEventListener('touchstart', handleTouchStart);
		window.addEventListener('touchend', handleTouchEnd);
		window.addEventListener('touchmove', handleTouchMove(animateSpline, position, getVisibleElementIndex, controls));
	}
}

function handleScroll(animateSpline, position, getVisibleElementIndex, controls) {
	console.log('init handleScroll');
	return () => {
	console.log('return handleScroll');
		if(!isThrottled) {
			isThrottled = true;
			requestAnimationFrame(() => {
				isThrottled = false;
			        if(!isTouching) {
					processScroll(animateSpline, position, getVisibleElementIndex, controls);
				}
				if(1==0) {
					resetAnimation(0 ,getVisibleElementIndex, animateSpline, controls);
//					window.scrollTo(0,0);
				}
			});
		}
	};
}

function handleTouchStart(e) {
	touchStartY = e.touches[0].clientY;
	isTouching = true;
}
function handleTouchEnd(e) {
	isTouching = false;
}

function handleTouchMove(animateSpline, position, getVisibleElementIndex, controls) {
    return (e) => {
	if(!isThrottled && !controls.enabled) {
		isThrottled = true;
		requestAnimationFrame(() => {
			isThrottled = false;
		        const touchEndY = e.changedTouches[0].clientY;
//		        const isScrollingDown = touchStartY < touchEndY - 50;
//		        const isScrollingUp = touchEndY < touchStartY - 50;
        		let currentScrollPosition = UTIL.roundNumber(window.scrollY || document.documentElement.scrollTop, 0);
        //		if (isScrollingDown && currentScrollPosition > getState('lastScrollPosition')) {
		        	processScroll(animateSpline, position, getVisibleElementIndex, controls, e);
	//	        } else if (isScrollingUp && currentScrollPosition < getState('lastScrollPosition')) {
	//	        	processScroll(animateSpline, position, getVisibleElementIndex, controls);
        	//	}
		});
	}
    };
}

function animationInProgress() {
	return getState('animationInProgress'); 
}

function isScrollingDown(e=null) {
	if(isTouching) {
		const touchEndY = e.changedTouches[0].clientY;
		return touchStartY > touchEndY - 50;
	}
        let currentScrollPosition = UTIL.roundNumber(window.scrollY || document.documentElement.scrollTop, 0);
	let lastScrollPosition = UTIL.roundNumber(getState('lastScrollPosition'), 0);
	return currentScrollPosition > lastScrollPosition + 50;
}

function isScrollingUp(e=null) {
	if(isTouching) {
		const touchEndY = e.changedTouches[0].clientY;
		return touchStartY < touchEndY - 50;
	}
        let currentScrollPosition = UTIL.roundNumber(window.scrollY || document.documentElement.scrollTop, 0);
	let lastScrollPosition = UTIL.roundNumber(getState('lastScrollPosition'), 0);
	return currentScrollPosition < lastScrollPosition;
}

async function processScroll(animateSpline, position, getVisibleElementIndex, controls, e) {
	if(!animationInProgress()) {
		if(!isScrollingUp(e) && !isScrollingDown(e) && window.scrollY < 50) {
			resetAnimation(0, getVisibleElementIndex, animateSpline, controls);
		}
		if(isScrollingDown(e)) {
			if(getState('lastElementScrolled')===overlayContentElements.length) {
				return;
			}
			if (getState('visibleElementIndex') >= getState('lastElementScrolled')) {
				if(getState('visibleElementIndex') >= overlayContentElements.length) {
					return;
				}
				if (window.scrollY < 50) {
					setState('lastElementScrolled', -1);
				}
				if(await startAnimation(animateSpline, controls)) {
					return;
				}
			} else {
				if (getState('visibleElementIndex') > getState('lastElementScrolled')) {
					await startAnimation(animateSpline, controls);
				}
			}
			if(getState('lastElementScrolled') > 0 && getState('visibleElementIndex') === -1) {
				setState('clear', true);
				animateSpline();
				return;
			}
		}
		if(isScrollingUp(e)) {
		if (Date.now() - getState('animationEndTime') >= 1000) {
				let visibleElementIndex = getVisibleElementIndex();
				if(visibleElementIndex!==-1 && visibleElementIndex>=0 && visibleElementIndex < overlayContentElements.length) {
					resetAnimation(position,getVisibleElementIndex, animateSpline, controls);
				}
				if(visibleElementIndex<=0 && window.scrollY < 150) {
					setState('clear', true);
					animateSpline(true);
					return;
				}
			}
		}
	}
	if(animationInProgress()) {
	}
}

function resetAnimation(position, getVisibleElementIndex, animateSpline, controls) {
	let index = getVisibleElementIndex();
	if(index>-1) {
		window.scrollTo({ top: position });
		setState('lastScrollPosition', position);
		setState('lastElementScrolled', -1);
		setState('clear', true);
		animateSpline(true);
		enableControls();
		disableScroll();
		firstStarted = false;
		showIcon360();
		showIconDown();
	}
	animateSmart();
	return;
}

async function initAnimation() {
	disableScroll();
	disableControls()
	await setState('animationInProgress', true);
	setState('animationStartTime', Date.now());
	setState('animationEndTime', null);
	setState('clear', true);
	hideIcon360();
	hideIconDown();
}

async function startAnimation(animateSpline, controls) {
	if (Date.now() - getState('animationEndTime') >= 1000) {
		await initAnimation();
		if(!firstStarted) {
			firstStarted = true;
			animateSpline();
			return true;
		} else {
			getVisibleElementIndex();
			let newIndex = getState('visibleElementIndex')+1;
			if(overlayContentElements.length>newIndex) {
				setState('visibleElementIndex', getState('visibleElementIndex')+1);
				animateSpline();
				return true;
			} else {
				if(overlayContentElements.length==newIndex) {
					setState('lastElementScrolled', newIndex);
					const element = overlayContentElements[getState('visibleElementIndex')];
					const height = parseInt(element.style.height); 
					const topOffset = element.offsetTop;
					const newPos = height + topOffset + window.innerHeight*2 + 36;
					clearModal();
					hideIcon();
					threejsLayer.classList.remove('layerbg');
					window.scrollTo({
						top: newPos,
					});
					setState('lastScrollPosition', newPos);
					enableScroll();
					setState('animationInProgress', false);
					setState('visibleElementIndex', getVisibleElementIndex());
					setState('animationEndTime', Date.now());
					return false;
				} else {
				}
			}
		}
	}
	return false;
}

export function disableScroll() {
	if(window.innerWidth<900) {
		document.body.classList.add('no-scroll');
	}
}

export function enableScroll() {
	if(window.innerWidth<900) {
		document.body.classList.remove('no-scroll');
	}
}

document.addEventListener('DOMContentLoaded', () => {
        let offset = 80;
        if (window.innerWidth >= 900) {
                offset = 100;
        }
        if (window.innerWidth >= 1024) {
                offset = 112;
        }
        const anchorLinks = document.querySelectorAll('a[href^="#"]');
        anchorLinks.forEach(link => {
                const handleScroll = function(e) {
                        e.preventDefault();
                        const targetId = this.getAttribute('href');
			if(targetId == '#') return;
                        const targetElement = document.querySelector(targetId);
                        if (targetElement) {
                                const elementPosition = targetElement.getBoundingClientRect().top;
                                const offsetPosition = elementPosition + window.pageYOffset - offset;
                                window.scrollTo({
                                        top: offsetPosition,
                                        behavior: 'smooth'
                                });
                                setTimeout(() => {
                                        const newElementPosition = targetElement.getBoundingClientRect().top;
                                        const newOffsetPosition = newElementPosition + window.pageYOffset - offset;
                                        if (Math.abs(newOffsetPosition - offsetPosition) > 1) {
                                                window.scrollTo({
                                                        top: newOffsetPosition,
                                                        behavior: 'smooth'
                                                });
                                        }
                                }, 150);
                        }
                };
                link.addEventListener('click', handleScroll);
                link.addEventListener('touchend', handleScroll);
        });
	const icons = document.querySelectorAll('.icon_down');
	icons.forEach(function(icon) {
		icon.addEventListener('click', function() {
			setState('visibleElementIndex', getVisibleElementIndex());
			setState('animationEndTime', 0);
		 	startAnimation(animateSpline, controls);	
		});
	});
});
